interface RemoveColumnProps{
    className?: string
}

export default function RemoveColumn({ className }: RemoveColumnProps) {
    return <svg
        width="194.40327mm"
        height="290.853mm"
        viewBox="0 0 194.40327 290.85299"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        style={{ fill: 'currentcolor' }}
    >

        <g>
            <rect
                width="50.962246"
                height="290.853"
                x="143.44104"
                y="2.4868996e-14"
                rx="15.05095"
                ry="17.061689" />
            <rect
                width="110.35661"
                height="35.805271"
                x="0"
                y="127.52386"
                rx="3.96875" />
        </g>
    </svg>
}